import { create } from "zustand";
import { configurePersist } from "zustand-persist";

const { persist: _persist } = configurePersist({
  storage: sessionStorage,
  rootKey: "root",
});

const persist = _persist as any;

interface GoogleAuth {
  isLoading?: boolean;
  accessToken?: string;
  microsoftToken?: string;
  email?: string;
  data?: any;
}
interface AuthStore extends GoogleAuth {
  setAuth: (auth: GoogleAuth | ((auth: GoogleAuth) => GoogleAuth)) => void;
  clear: () => void;
}

export const useGoogleAuthStore = create<AuthStore>(
  persist(
    {
      key: "auth",
    },
    (set: any) => ({
        isLoading: false,
      accessToken: undefined,
      microsoftToken: undefined,
      email: undefined,

      setAuth: (auth: GoogleAuth | ((auth: GoogleAuth) => GoogleAuth)) => {
        if (typeof auth === "function") {
          set((_state: GoogleAuth) => auth(_state));
        } else {
          set((_state: GoogleAuth) => auth);
        }
      },
      clear: () => {
        set((_state: GoogleAuth) => ({
          isAuthenticated: false,
          accessToken: "",
          microsoftToken: "",
          name: "",
          email: "",
          id: "",
          data: undefined,
          isLoading: false
        }));
      },
    })
  )
);
